import PreferencesHitPointConfirmPane from './PreferencesHitPointConfirmPane';

export default PreferencesHitPointConfirmPane;
export { PreferencesHitPointConfirmPane };
